import script from "./GeneralSetupStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralSetupStep.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralSetupStep.vue?vue&type=style&index=0&id=4a4330fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4330fa"]])

export default __exports__